import useInlineHelp from '@amzn/carrier-logistics-inline-help-ui-assets/dist/hooks/useInlineHelp';
import helpIconToken from '@amzn/meridian-tokens/base/icon/help';
import Button from '@amzn/meridian/button';
import Icon from '@amzn/meridian/icon';
import React from 'react';
import { useLocation } from 'react-router-dom';
import {
  DEFAULT_PAGE, NPC_DEFAULT_STRATEGY, NPC_STRATEGY_KEY, ROUTE_MAPPING,
} from '../constants/symphonyPageMapping';
import { NPC_PATH } from '../config/navigationalRoutes';

const InlineHelpModule = () => {
  const { openInlineHelpSheet } = useInlineHelp();
  const { pathname } = useLocation();
  const handleHelpIconClick = () => {
    // TODO: add all the pages routes which gets onboarded to inline help
    if (ROUTE_MAPPING[pathname]) {
      if (NPC_PATH === pathname) {
        const npcStrategy = window.sessionStorage.getItem(NPC_STRATEGY_KEY);
        const npcPageId = npcStrategy === NPC_DEFAULT_STRATEGY
          ? ROUTE_MAPPING[pathname] : `${ROUTE_MAPPING[pathname]}-na`;
        openInlineHelpSheet(npcPageId);
      } else {
        openInlineHelpSheet(ROUTE_MAPPING[pathname]);
      }
    } else {
      openInlineHelpSheet(DEFAULT_PAGE);
    }
  };
  return (
    <Button type="icon" size="small" label="Help" onClick={handleHelpIconClick}>
      <Icon tokens={helpIconToken} />
    </Button>
  );
};

export default InlineHelpModule;
